<template lang="pug">
  b-card(no-body class="boletas-card")
    b-card-body
      b-row.row-title.pb-3
        b-icon-receipt.mr-2.title
        h3.title Documentos Tributarios
      .data-list
        .data-item
          h4.data-label Requiere Abono
          h4.data-info {{ ovData.requiere_abono ? 'Si' : 'No' }}
        .data-item
          h4.data-label Abono Requerido
          h4.data-info {{ formatCurrency(ovData.abono_requerido) }}
        .data-item
          h4.data-label Monto Abonado
          h4.data-info {{ formatCurrency(ovData.monto_abonado) }}
        .data-item(v-if="mostrarSaldoPendiente")
          h4.data-label Saldo Pendiente
          h4.data-info {{ formatCurrency(ovData.saldo_pendiente) }}
        .data-item
          h4.data-label N° Boleta/Factura Abono
          h4.data-info {{ ovData.numero_boleta_abono }}
        .data-item.mt-2
          h4.data-label Monto Total con IVA
          h4.data-info {{ formatCurrency(ovData.monto_total_final) }}
        .data-item
          h4.data-label N° Boleta/Factura Pago Final
          h4.data-info {{ ovData.numero_boleta_pago_final }}
</template>

<script>
export default {
  name: 'OVDetailBoletas',
  props: {
    ov: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ovData() {
      return {
        requiere_abono: this.ov.requiere_abono || false,
        abono_requerido: this.ov.abono_requerido || 0,
        monto_abonado: this.ov.monto_abonado || 0,
        monto_total_final: this.ov.monto_total_final || 0,
        numero_boleta_abono: this.ov.nro_boleta_abono || '-',
        numero_boleta_pago_final: this.ov.nro_boleta_pago || '-',
        saldo_pendiente: this.ov.resumen_montos?.saldo_pendiente || 0,
      }
    },
    mostrarSaldoPendiente() {
      const monto_abonado = this.ov.monto_abonado || 0
      const saldo = this.ov.resumen_montos?.saldo_pendiente || 0
      return monto_abonado > 0 && saldo > 0
    },
  },
  methods: {
    formatCurrency(value) {
      if (!value || value === 0) return '$0'
      return `$${value.toLocaleString('es-CL', { useGrouping: true })}`
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.boletas-card {
  border: none;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.title {
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0;
  color: #23201c;
}

.row-title {
  align-items: center;
  padding-left: 15px;
  padding-right: 15px;
}

.data-list {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.data-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.data-label {
  font-size: 0.9rem;
  font-weight: 700;
  color: #525252;
  margin: 0;
}

.data-info {
  font-size: 0.9rem;
  font-weight: 400;
  color: #525252;
  margin: 0;
}
</style>
